<p-drawer [visible]="emily.visible()" [closable]="true" (visibleChange)="emily.visible.set($event)" position="right"
          [modal]="true" [blockScroll]="true" [style]="{ width: '95%' }" (onShow)="init()" (onHide)="clear()">
  <ng-template #header>
    <div class="p-2 flex items-center gap-2">
      <p-avatar shape="circle"/>
      <div>
        <span>Emily</span>
        <div class="flex flex-row space-x-1 items-center">
          <p-badge severity="success"></p-badge>

          <small>Online • AI Assistant</small>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #content>
    <div class="p-2">
      <div class="message-section space-y-2">
        @for (message of messages(); track $index) {
          @if (message.sender === 'emily') {
            <div class="flex flex-col items-start space-y-2">
              @for (seg of (message.text | emilySegments); track $index) {
                @switch (seg.kind) {
                  @case ('table') {
                    <div class="emily-table emily-md">
                      <button type="button" class="copy-btn" (click)="copyMenuRef.toggle($event)"
                              aria-haspopup="true" aria-label="Copy table">
                        <i class="pi pi-copy"></i>
                      </button>
                      <p-menu #copyMenuRef [model]="copyMenu(seg.tsv, seg.csv)" [popup]="true"
                              appendTo="body"></p-menu>
                      <div [innerHTML]="seg.html"></div>
                    </div>
                  }
                  @case ('note') {
                    <div class="emily-note emily-md" [innerHTML]="seg.html"></div>
                  }
                  @default {
                    <div class="message emily emily-md" [innerHTML]="seg.html"></div>
                  }
                }
              }
            </div>
          } @else {
            <div>
              <div class="message user">{{ message.text }}</div>
            </div>
          }
        }
        @if (thinking()) {
          <div class="message emily small">
            <div class="flex flex-row space-x-1">
              <p-skeleton shape="circle" size="0.75rem"/>
              <p-skeleton shape="circle" size="0.75rem"/>
              <p-skeleton shape="circle" size="0.75rem"/>
            </div>
          </div>
        }
        <div #bottomAnchor></div>
      </div>
    </div>

  </ng-template>
  <ng-template #footer>
    <div class="try-bar">
      <p-divider></p-divider>
      <button type="button" class="try-header" [attr.aria-expanded]="tryExpanded()" (click)="toggleTry()">
        <span>Need some prompt ideas?</span>
        <i class="pi pi-chevron-down try-header__chevron" [class.try-header__chevron--collapsed]="!tryExpanded()"></i>
      </button>
      <div class="button-row" [class.try-bar__body--collapsed]="!tryExpanded()">
        @for (b of buttons; track b.title) {
          <p-button [size]="'small'" [disabled]="thinking()" [title]="b.prompt" (click)="fillInput(b.prompt)">
            {{ b.title }}
          </p-button>
        }
      </div>
    </div>
    <p-divider></p-divider>
    <div class="p-2 flex flex-row space-x-2 justify-between items-end">
      <textarea #emilyInput pTextarea class="emily-input flex-grow" placeholder="Ask Emily anything..." rows="1"
                [autoResize]="true" [(ngModel)]="input" (keydown.enter)="onEnterKey($event)"
                [dt]="{borderRadius: '18px'}"></textarea>
      <p-button [pt]="{root:{primary:{background:'red'}}}"
                size="small"
                severity="primary"
                (click)="sendInput()"
                [disabled]="!input || thinking()">
        <i class="pi pi-send"></i>
      </p-button>
    </div>

  </ng-template>
</p-drawer>
